import React from "react";
import { statusLabel } from "../lib/utils-app";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

export default function StatusBadge({ status }) {
  const cls = status === "expired" ? "status-expired" : status === "expiring" ? "status-expiring" : "status-valid";
  const Icon = status === "expired" ? XCircle : status === "expiring" ? AlertTriangle : CheckCircle2;
  return (
    <span className={`status-pill ${cls}`} data-testid={`status-${status}`}>
      <Icon size={12} />
      {statusLabel(status)}
    </span>
  );
}
